module.exports = __webpack_public_path__ + "static/media/img2-2.9927812c.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/nutricheck_suelo/CA/img2-2.png
// module id = 2332
// module chunks = 3